<content-container>
  <div content-slot>
    <title-component title="ODKODUJ" [decoration]="true"></title-component>
    <content-component>
      <p>
        Wpisz zaszyfrowana wiadomość lub wybierz zaszyfrowany wynik, by go
        odszyfrować.
      </p>
    </content-component>
    <input-component
      placeholder="Wpisz treść do odszyfrowania"
      (inputValueChange)="encryptionValue($event)"
    ></input-component>
    <div *ngIf="encryptionItemList.length > 0">
      <title-component subtitle="WYNIKI SZYFROWANIA"></title-component>
      <result-row-list [result]="encryptionItemList"></result-row-list>
    </div>
  </div>
  <div image-slot>
    <img src="/assets/image/bg_image_encryption.png" />
  </div>
</content-container>
